/**
 * DemoDataBanner — persistent disclosure that this app is a preview running
 * on demo data (PB-6, ONBOARD-AUDIT Phase 1b 2026-06-11).
 *
 * The dashboard KPIs, customer/product lists, and the H2O Driverless AI
 * sections render hardcoded template data with no backend. Until they are
 * wired (or stripped), every screen must say so.
 */

const bannerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  backgroundColor: '#fef3c7',
  borderBottom: '1px solid #fcd34d',
  color: '#78350f',
  fontSize: 12,
  fontWeight: 500,
  padding: '6px 16px',
  fontFamily: 'inherit',
};

const DemoDataBanner = () => (
  <div role="status" style={bannerStyle}>
    <span aria-hidden="true">⚗️</span>
    <span>
      Demo preview — the data shown in this app is illustrative, not live
      clinical or business data.
    </span>
  </div>
);

export default DemoDataBanner;
